<template>
  <div>
    <Header />

    <!-- 麵包屑導覽 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            International Student Application System
          </li>
        </ol>
      </div>
    </nav>

    <div class="main form">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <div class="box">
          <div class="title">
            <h2>International Student Application System</h2>
            <div class="btn_box">
              <button class="tours_btn" @click="startTour">
                <svg width="28" height="28" viewBox="0 0 28 28">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="_3" data-name="3" width="28" height="28" transform="translate(5575 10526)" fill="none"
                        stroke="#707070" stroke-width="1" />
                    </clipPath>
                  </defs>
                  <g id="icon_instructions" transform="translate(-5575 -10526)" clip-path="url(#clip-path)">
                    <g id="_2" data-name="2" transform="translate(5575.14 10526.5)">
                      <path id="_1" data-name="1"
                        d="M23.14,21.36a1,1,0,0,0,1-1V3.42A1.929,1.929,0,0,0,22.21,1.5H8.69V19.358h-2V1.5H5.93A3.077,3.077,0,0,0,2.86,4.57V22.43c0,.011.006.021.007.032A3.069,3.069,0,0,0,5.934,25.5h17.2a1,1,0,0,0,0-2H5.934a1.07,1.07,0,0,1,0-2.14H23.14Zm-7.751-15a1.007,1.007,0,0,1,1.021,1,1,1,0,0,1-2,0,1,1,0,0,1,.979-1ZM14.41,11.19a1,1,0,0,1,2,0v3.96a1,1,0,0,1-2,0Z"
                        fill="#580d63" />
                    </g>
                  </g>
                </svg>
                Instructions
              </button>
            </div>
          </div>

          <ul class="progress_bar">
            <li v-for="(item, index) in progressItems" :key="index">
              <router-link :to="item.to" :class="['step_box', getStepClass(index)]">
                <div class="step">
                  <p v-if="index != 6">Step {{ index + 1 }}</p>
                  <p v-else>Payment</p>
                  <p>{{ item.title }}</p>
                </div>
                <div class="line"></div>
              </router-link>
            </li>
          </ul>

          <!-- 載入指示器 -->
          <div v-if="isLoading" class="loading-container" style="text-align: center; padding: 40px;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Loading...</span>
            </div>
            <p style="margin-top: 20px; font-size: 16px;">Loading payment information...</p>
          </div>

          <template v-else>
            <div class="bg">
              <div class="title_box description">
                <h3>{{ stepContent.title }}</h3>
              </div>

              <div v-if="stepContent.content" class="text_box" id="step1" v-html="stepContent.content"></div>
            </div>

            <div class="bg" v-if="userPrograms.length > 0">
              <div class="title_box">
                <h3>Applying Program</h3>
              </div>

              <!-- 如果沒有申請任何系所 -->
              <!-- <div v-if="userPrograms.length === 0"
                style="padding: 40px; text-align: center; background: #f9f9f9; border-radius: 8px; width: 100%;">
                <p style="margin: 0; color: #999; font-size: 16px;">
                  No programs have been applied for yet. Please go to Step 2 to select a program.
                </p>
                <button class="btn" @click="gotoForm_2" style="margin-top: 20px;">
                  Go to Step 2
                </button>
              </div> -->

              <!-- 顯示已申請的系所列表 -->
              <template>
                <ul class="department_list" id="step2">
                  <li class="" v-for="(item, index) in userPrograms" :key="item.pId">
                    <div class="">
                      <div class="number">{{ index + 1 }}</div>
                    </div>
                    <div class="department">
                      <p>
                        {{ item.college }}
                      </p>
                      <p>
                        {{ item.program }}
                      </p>
                      <p style="color: #888; font-size: 14px;">{{ item.degree }}</p>
                    </div>

                    <div class="price">
                      <!-- 不顯示個別價格，因為是按總數計算 -->
                      <p style="color: #888;">-</p>
                    </div>
                  </li>
                </ul>

                <div class="fees_box">
                  <div>
                    Total:
                    <span>{{ totalPrograms }}</span>
                    Program{{ totalPrograms > 1 ? 's' : '' }} Applied
                  </div>
                  <div class="total_price">
                    <p>
                      TWD :
                      <span> {{ formattedTWD }}</span>
                    </p>
                    <p>
                      ( USD :
                      <span> {{ formattedUSD }} </span>
                      )
                    </p>
                  </div>
                </div>
              </template>

              <div class="bg" style="width: 100%;" v-if="payNotes">
                <div class="title_box description">
                  <h3>NOTES</h3>
                </div>

                <div class="text_box" v-html="payNotes">
                </div>
              </div>

              <!-- 訂單資訊區塊 -->
              <div class="bg" style="width: 100%;" v-if="hasOrder && orderInfo">
                <div class="title_box description">
                  <h3>Order Information</h3>
                </div>

                <div class="text_box">
                  <div style="display: grid; grid-template-columns: 200px 1fr; gap: 15px; padding: 10px 0;">
                    <div style="font-weight: bold;">Order Number:</div>
                    <div>{{ orderInfo.applyOrderId }}</div>

                    <div style="font-weight: bold;">Application ID:</div>
                    <div>{{ orderInfo.applyID }}</div>

                    <div style="font-weight: bold;">Order Status:</div>
                    <div>
                      <span v-if="orderInfo.status === 0" style="color: #ff9800;">Pending Payment</span>
                      <span v-else-if="orderInfo.status === 1" style="color: #4caf50;">Paid</span>
                      <span v-else-if="orderInfo.status === 2" style="color: #f44336;">Cancelled</span>
                      <span v-else>Unknown</span>
                    </div>

                    <div style="font-weight: bold;">Order Amount:</div>
                    <div>TWD {{ orderInfo.amount ? orderInfo.amount.toLocaleString('zh-TW') : '0' }}</div>

                    <div style="font-weight: bold;">Payment Method:</div>
                    <div>
                      <span v-if="orderInfo.payment === 1">Credit Card</span>
                      <span v-else-if="orderInfo.payment === 2">Domestic Transfer</span>
                      <span v-else-if="orderInfo.payment === 3">Foreign Transfer</span>
                      <span v-else>Not Selected</span>
                    </div>

                    <div style="font-weight: bold;" v-if="orderInfo.status === 1 && orderInfo.amount > 0">Payment Time:
                    </div>
                    <div v-if="orderInfo.status === 1 && orderInfo.amount > 0">{{ orderInfo.payTime ?
                      formatDateTime(orderInfo.payTime) : 'Not Paid Yet' }}
                    </div>

                    <!-- <div style="font-weight: bold;">Cleared Status:</div>
                    <div>
                      <span v-if="orderInfo.isCleared" style="color: #4caf50;">✓ Cleared</span>
                      <span v-else style="color: #ff9800;">Pending</span>
                    </div> -->

                    <div style="font-weight: bold;" v-if="orderInfo.note">Note:</div>
                    <div v-if="orderInfo.note">{{ orderInfo.note }}</div>
                  </div>
                </div>
              </div>

              <template v-if="!isLDCCountry">
                <div class="form-group full check_block"
                  v-if="userPrograms.length > 0 && orderInfo && orderInfo.status !== 1 && orderInfo.payment === 0">
                  <label for=""><span class="required">*</span>Make Payment (You may make
                    payment after well prepared all requirements)</label>

                  <div class="check_group">
                    <div class="form-check" v-if="payMethod.creditCard">
                      <input class="form-check-input" type="radio" name="MakePayment" id="MakePayment1" value="credit"
                        v-model="paymentMethod" />
                      <label class="form-check-label" for="MakePayment1">
                        Credit card
                      </label>
                    </div>
                    <div class="form-check" v-if="payMethod.domesticTransfer">
                      <input class="form-check-input" type="radio" name="MakePayment" id="MakePayment2" value="domestic"
                        v-model="paymentMethod" />
                      <label class="form-check-label" for="MakePayment2">
                        Domestic Payment (can only be done in Taiwan)
                      </label>
                    </div>
                    <div class="form-check" v-if="payMethod.foreignTransfer">
                      <input class="form-check-input" type="radio" name="MakePayment" id="MakePayment3" value="foreign"
                        v-model="paymentMethod" />
                      <label class="form-check-label" for="MakePayment3">
                        Foreign Payment
                      </label>
                    </div>
                  </div>

                  <div class="btn_box Pay_btn">
                    <button class="btn add" @click="handlePayment" :disabled="!paymentMethod || isSaving">
                      {{ isSaving ? 'Processing...' : 'Select Payment' }}
                    </button>
                  </div>
                </div>

                <!-- 付款證明上傳區塊 -->
                <div class="form-group file_box full"
                  v-if="userPrograms.length > 0 && orderInfo">
                  <label for="paymentProof">
                    <span class="required">*</span>Upload Payment Proof
                  </label>
                  <p class="notice" style="margin-bottom: 10px; color: #666;">
                    Please upload proof of your payment (bank transfer receipt, transaction screenshot, etc.)
                  </p>

                  <div class="file_input">
                    <input type="file" class="form-control" id="paymentProof" @change="handlePaymentProofChange"
                      :disabled="uploadingProof" accept="image/*,.pdf" />
                    <div class="upload">{{ uploadingProof ? 'Uploading...' : 'Upload' }}</div>
                  </div>

                  <!-- 顯示已上傳的付款證明 -->
                  <div v-if="orderInfo.paymentProof" class="uploaded-file-info">
                    <a :href="$store.state.src + $store.state.subDirectory + orderInfo.paymentProof" target="_blank"
                      class="file_a" style="background-color: #4caf50; color: #FFFFFF; margin-top: 10px;">
                      View Uploaded Payment Proof
                    </a>
                  </div>
                </div>

                <!-- 簽名申請表上傳區塊 -->
                <div class="form-group file_box full"
                  v-if="userPrograms.length > 0 && orderInfo">
                  <label for="signedApplicationForm">
                    <span class="required">*</span>Upload Signed Application Form
                  </label>
                  <p class="notice" style="margin-bottom: 10px; color: #666;">
                    Please print the application form from the 
                    <router-link to="/Apply/Check" style="color: #580d63; font-weight: bold; text-decoration: underline;">
                      Review & Submit page
                    </router-link>, 
                    sign it, and upload the signed copy here.
                  </p>

                  <div class="file_input">
                    <input type="file" class="form-control" id="signedApplicationForm" 
                      @change="handleSignedFormChange"
                      :disabled="uploadingSignedForm" accept="image/*,.pdf" />
                    <div class="upload">{{ uploadingSignedForm ? 'Uploading...' : 'Upload' }}</div>
                  </div>

                  <!-- 顯示已上傳的簽名申請表 -->
                  <div v-if="applicationData && applicationData.signedApplicationForm" class="uploaded-file-info">
                    <a :href="$store.state.src + $store.state.subDirectory + applicationData.signedApplicationForm" 
                      target="_blank"
                      class="file_a" style="background-color: #4caf50; color: #FFFFFF; margin-top: 10px;">
                      View Uploaded Signed Application Form
                    </a>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="title_box description">
                  <h3>Payment Exemption Notice</h3>
                </div>

                <div class="text_box">
                  <p>
                    According to the regulations of the Ministry of Education, applicants from
                    countries classified as Least Developed Countries (LDC) are exempted from
                    paying the application fee. As your country falls under this category,
                    you are not required to make any payment for your application.
                  </p>
                  <p>
                    Please proceed with your application without any payment concerns.
                    If you have any questions or need further assistance, feel free to
                    contact our admissions office.
                  </p>
                  <p>We wish you the best of luck with your application!</p>
                </div>
              </template>
            </div>

            <!-- <div class="btn_box">
              <button class="btn" @click="gotoPrev">Previous</button>
              <button class="btn" @click="gotoNext">Next</button>
            </div> -->
          </template>

          <!-- 彈跳視窗公告 -->
          <div v-if="showModal" class="modal attention_box">
            <div class="bg">
              <div class="title_box">
                <h3>{{ this.stepContent.alertTitle }}</h3>
              </div>

              <div class="text_box" v-html="this.stepContent.alertContent">
              </div>

              <div class="btn_box">
                <button class="btn" @click="loadUserOrder">OK</button>
                <button class="btn" @click="gotoForm_1">Back To Step 1</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from "@/services/applyStudent.js";
import Swal from "sweetalert2";

import { driver } from "driver.js";

export default {
  name: "Form_Pay",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // 進度步驟
      currentStep: 6, // 表示第6步（index 5）
      progressItems: [
        { to: "/Apply/1", title: "Fill out online application form" },
        { to: "/Apply/2", title: "Apply for a program" },
        {
          to: "/Apply/3",
          title:
            "Fill out Recommenders (Do Not Fill Out Without Notifying Your Recommenders in Advance.)",
        },
        { to: "/Apply/4", title: "Upload Required Documents 1" },
        { to: "/Apply/5", title: "Upload Required Documents 2" },
        { to: "/Apply/Check", title: "Review & Submit" },
        { to: "/Apply/Pay", title: "Pay Application Fee" },
      ],

      driverObj: null,
      arr: [
        {
          element: "#step1",
          popover: {
            description: "Fee information and notes",
            side: "top",
            align: "start",
          },
        },
        {
          element: "#step2",
          popover: {
            description: "Applied programs with fees",
            side: "bottom",
            align: "start",
          },
        },
      ],

      // 步驟內容
      stepContent: {
        step: 6,
        title: 'Pay Application Fee',
        alertEnable: false,
        alertTitle: '',
        alertContent: '',
        content: '',
        applyInfo: null
      },

      payMethod: {
        creditCard: false,
        domesticTransfer: false,
        foreignTransfer: false
      },

      // 彈跳視窗公告
      showModal: false,

      // 申請表ID
      asId: null,

      // 申請表資料
      applicationData: null,

      // 載入狀態
      isLoading: false,

      // 儲存中狀態
      isSaving: false,

      // 使用者申請的學程列表
      userPrograms: [],

      // 所有可用學程
      allPrograms: [],

      // 付款方式選擇
      paymentMethod: '', // 'credit' 或 'domestic'

      // 申請人狀態選擇
      applicantStatus: '', // 'regular' 或 'discount'

      // 費用設定（固定費用，依據申請的系所數量）
      // 1-2 個系所: TWD 2000 / USD 80
      // 3-4 個系所: TWD 4000 / USD 160
      feeConfig: {
        '1-2': { TWD: 2000, USD: 80 },
        '3-4': { TWD: 4000, USD: 160 }
      },

      // 是否為 LDC 國家（免費）
      isLDCCountry: false,

      payNotes: '',

      // 訂單資訊
      orderInfo: null, // 包含訂單的完整資訊
      hasOrder: false, // 是否已建立訂單

      // 付款證明上傳狀態
      uploadingProof: false,

      // 簽名申請表上傳狀態
      uploadingSignedForm: false,

      aId: null, // 申請學期梯次ID
    };
  },

  computed: {
    // 所選系所數量
    totalPrograms() {
      return this.userPrograms.length;
    },

    // 計算總費用 (TWD)
    // 費用規則: 1-2個系所 TWD 2000, 3-4個系所 TWD 4000, LDC國家免費
    totalTWD() {
      if (this.isLDCCountry) {
        return 0; // LDC 國家免費
      }

      const programCount = this.userPrograms.length;

      if (programCount === 0) {
        return 0;
      } else if (programCount <= 2) {
        return this.feeConfig['1-2'].TWD;
      } else if (programCount <= 4) {
        return this.feeConfig['3-4'].TWD;
      }

      // 如果超過4個系所，返回4個系所的費用（理論上最多4個）
      return this.feeConfig['3-4'].TWD;
    },

    formattedTWD() {
      return this.totalTWD.toLocaleString("zh-TW");
    },

    // 計算總費用 (USD)
    // 費用規則: 1-2個系所 USD 80, 3-4個系所 USD 160, LDC國家免費
    totalUSD() {
      if (this.isLDCCountry) {
        return 0; // LDC 國家免費
      }

      const programCount = this.userPrograms.length;

      if (programCount === 0) {
        return 0;
      } else if (programCount <= 2) {
        return this.feeConfig['1-2'].USD;
      } else if (programCount <= 4) {
        return this.feeConfig['3-4'].USD;
      }

      // 如果超過4個系所，返回4個系所的費用（理論上最多4個）
      return this.feeConfig['3-4'].USD;
    },

    formattedUSD() {
      return this.totalUSD.toLocaleString("zh-TW");
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    this.initializeForm();
  },

  methods: {
    // ========== 頁面初始化 ==========

    /**
     * 初始化表單 - 載入所有必要資料
     */
    async initializeForm() {
      this.isLoading = true;
      try {
        const checkResult = await applyStudentService.checkUserApplication();
        if (!checkResult.success || !checkResult.data ||
          !checkResult.data?.isReview ||
          checkResult.data?.isAgree != 1) {
          Swal.fire({
            icon: "warning",
            title: "Eligibility review not completed",
            text: "Please complete the dual citizenship check and agree to the terms and conditions first.",
            confirmButtonText: "OK"
          }).then(() => {
            this.$router.push("/Profile");
          });
          return;
        }

        // 載入使用者申請表資料和學程
        await this.loadUserApplication();

        await this.loadStepContent();
        await this.loadPayNotes();
        await this.loadPayMethod();

        // 若沒有選擇任何學程，跳轉回步驟2
        if (this.userPrograms.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "No Programs Selected",
            text: "Please select at least one program in Step 2 before proceeding to payment.",
            confirmButtonText: "OK"
          }).then(() => {
            this.$router.push("/Apply/2");
          });
          return;
        }

        // 檢查 Form4 和 Form5 是否已完成上傳必要文件
        const hasMissingDocuments = await this.checkRequiredDocumentsCompletion();

        // 如果有缺少的必要文件，不繼續載入訂單資訊
        if (hasMissingDocuments) {
          return;
        }

        // 載入訂單資訊（在取得 asId 後）
        if (this.asId) {
          await this.checkUserOrder();
        }

      } catch (error) {
        console.error("Form initialization error:", error);
        Swal.fire({
          icon: "error",
          title: "Initialization Error",
          text: "Failed to initialize form. Please refresh the page.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isLoading = false;
      }
    },

    async loadPayMethod() {
      const result = await applyStudentService.getActiveApplyPayMethod(this.aId);
      if (result.success && result.data) {
        this.payMethod = result.data.paymentMethod;
      } else {
        // 使用預設值
        this.payMethod = {
          creditCard: false,
          domesticTransfer: false,
          foreignTransfer: false
        };
      }
    },

    // 載入步驟內容
    async loadStepContent() {
      const result = await applyStudentService.getActiveApplyStepContent(6, this.aId);
      if (result.success && result.data) {
        this.stepContent = result.data;
        if (!this.stepContent.title) {
          this.stepContent.title = 'Step 6';
        }
      } else {
        // 使用預設值
        this.stepContent = {
          step: 5,
          title: 'Step 6',
          alertEnable: false,
          alertTitle: '',
          alertContent: '',
          content: '',
          applyInfo: null
        };
      }
      //this.showModal = this.stepContent.alertEnable;
    },

    async loadPayNotes() {
      const result = await applyStudentService.getActiveApplyPayNotes(this.aId);
      if (result.success && result.data) {
        this.payNotes = result.data.paymentDescription;
      }
    },

    /**
     * 載入使用者申請表資料
     */
    async loadUserApplication() {
      const result = await applyStudentService.getUserApplication();

      if (result.success && (!result.data || !result.data.hasApplication)) {
        // 顯示請先完成基本資料並跳轉回Apply/1頁面
        Swal.fire({
          icon: "warning",
          title: "Incomplete Basic Information",
          text: "Please complete your basic information first.",
          confirmButtonText: "OK"
        }).then(() => {
          this.$router.push("/Apply/1");
        });
        return;
      }

      if (result.success && result.data) {
        // 儲存完整的申請表資料
        this.applicationData = result.data;
        this.aId = result.data.aId;
        this.asId = result.data.asId;

        // 確認是否免費
        const countryCode = result.data.permCountry;
        const feedata = await applyStudentService.getCountryInfo(countryCode);
        if (feedata.success && feedata.data) {
          console.log("Country LDC status:", feedata.data);
          this.isLDCCountry = !feedata.data.isNeedFee;
        }

        // 解析使用者申請的學程
        if (result.data.applyPrograms) {
          try {
            const programIds = JSON.parse(result.data.applyPrograms);
            await this.loadProgramsInfo(programIds);
          } catch (error) {
            console.error("Error parsing applyPrograms:", error);
            this.userPrograms = [];
          }
        }
      }
    },

    /**
     * 載入學程資訊
     */
    async loadProgramsInfo(programIds) {
      // 先載入所有可用學程
      const programsResult = await applyStudentService.getActiveApplyPrograms(this.aId);
      if (programsResult.success && programsResult.data) {
        const { programs, colleges } = programsResult.data;
        this.allPrograms = programs || [];

        // 為每個申請的學程載入詳細資訊
        this.userPrograms = [];
        for (const pId of programIds) {
          const program = this.allPrograms.find(p => p.pId === pId);
          if (program) {
            // 找到對應的學院名稱
            const college = colleges?.find(c => c.cId === program.cId);

            this.userPrograms.push({
              pId: pId,
              college: college?.name_EN || college?.name || 'Unknown College',
              program: program.name_EN || program.name,
              degree: this.getDegreeText(program.degree),
              // 注意: 單個項目不顯示價格，因為費用是按總數計算的
              // 顯示在列表中僅供參考
              TWDprice: '-',
              USDprice: '-',
            });
          }
        }
      }
    },

    /**
     * 檢查必要文件是否已全部上傳完成
     */
    async checkRequiredDocumentsCompletion() {
      if (!this.asId) {
        console.warn("Cannot check documents: asId is not available");
        return;
      }

      try {
        const result = await applyStudentService.checkRequiredDocuments(this.asId);

        if (result.success && result.data) {
          const { allComplete, generalComplete, departmentComplete, missingGeneralFiles, missingDepartmentFiles } = result.data;

          // 如果有未完成的必要文件上傳，顯示警告並阻止繼續
          if (!allComplete) {
            let warningHtml = '<div style="text-align: left; padding: 10px;">';
            warningHtml += '<p style="margin-bottom: 15px; font-size: 16px;">You have not completed uploading all required documents:</p>';

            if (!generalComplete && missingGeneralFiles.length > 0) {
              warningHtml += '<div style="margin-bottom: 20px;">';
              warningHtml += '<h4 style="color: #580d63; margin-bottom: 10px; font-size: 15px;">Missing General Documents (Step 4):</h4>';
              warningHtml += '<ul style="margin: 0; padding-left: 20px;">';
              missingGeneralFiles.forEach(file => {
                warningHtml += `<li style="margin-bottom: 5px; color: #d32f2f;">${file.name}</li>`;
              });
              warningHtml += '</ul>';
              warningHtml += '</div>';
            }

            if (!departmentComplete && missingDepartmentFiles.length > 0) {
              warningHtml += '<div style="margin-bottom: 20px;">';
              warningHtml += '<h4 style="color: #580d63; margin-bottom: 10px; font-size: 15px;">Missing Department-Specific Documents (Step 5):</h4>';
              warningHtml += '<ul style="margin: 0; padding-left: 20px;">';
              missingDepartmentFiles.forEach(file => {
                warningHtml += `<li style="margin-bottom: 5px; color: #d32f2f;">${file.name}</li>`;
              });
              warningHtml += '</ul>';
              warningHtml += '</div>';
            }

            warningHtml += '<p style="margin-top: 15px; font-weight: bold; color: #ff9800;">Please upload all required documents before proceeding to payment.</p>';
            warningHtml += '</div>';

            const confirmResult = await Swal.fire({
              icon: "warning",
              title: "Incomplete Document Upload",
              html: warningHtml,
              showCancelButton: false,
              confirmButtonText: "Go to Upload Documents",
              confirmButtonColor: "#580d63",
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            // 根據缺少的文件類型，跳轉到相應的頁面
            if (!generalComplete) {
              this.$router.push("/Apply/4");
            } else if (!departmentComplete) {
              this.$router.push("/Apply/5");
            }

            // 阻止繼續載入頁面
            return true; // 返回 true 表示有缺少的文件
          }

          return false; // 返回 false 表示所有文件都已上傳
        } else {
          console.warn("Failed to check required documents:", result.message);
        }
      } catch (error) {
        console.error("Error checking required documents:", error);
      }

      return false;
    },

    async checkUserOrder() {
      if (!this.asId) {
        console.warn("Cannot load order: asId is not available");
        return;
      }

      try {
        const result = await applyStudentService.hasUserOrder(this.asId);

        if (result.success && result.data) {
          this.hasOrder = result.data.hasOrder;
          if (this.hasOrder) {
            await this.loadUserOrder();
          } else {
            this.showModal = true;
          }
        } else {
          console.warn("Failed to load order information:", result.message);
          this.hasOrder = false;
        }
      } catch (error) {
        console.error("Error loading user order:", error);
        this.hasOrder = false;
      }
    },

    /**
     * 載入使用者訂單資訊
     */
    async loadUserOrder() {
      if (!this.asId) {
        console.warn("Cannot load order: asId is not available");
        return;
      }

      try {
        const result = await applyStudentService.getUserOrder(this.asId);

        if (result.success && result.data) {
          this.orderInfo = result.data;
          this.hasOrder = true;
          this.showModal = false;

          //console.log("Order information loaded:", this.orderInfo);

          // 可以根據訂單狀態更新 UI
          // status: 訂單狀態 (0: 待付款, 1: 已付款, 2: 已取消等)
          // isCleared: 是否已結清
          // payment: 付款方式 (0: 信用卡, 1: 國內轉帳, 2: 國外轉帳)

        } else {
          console.warn("Failed to load order information:", result.message);
          this.hasOrder = false;
        }
      } catch (error) {
        console.error("Error loading user order:", error);
        this.hasOrder = false;
      }
    },

    // ========== UI 互動 ==========

    // 進度步驟 不同狀態增加不同class
    getStepClass(index) {
      if (index < this.currentStep) {
        return "done"; // 已完成
      } else if (index === this.currentStep) {
        return "filling"; // 目前步驟
      }
      return "";
    },

    startTour() {
      // 建立 driver 實例，開始導覽
      this.driverObj = driver({
        showProgress: true,
        progressText: "{{current}}/{{total}}",
        showButtons: true,
        nextBtnText: "Next",
        prevBtnText: "Back",
        doneBtnText: "End Tour",
        animate: false,
        steps: this.arr,
      });

      this.driverObj.drive();
    },

    // 彈跳視窗關閉
    closeModal() {

      this.showModal = false;
    },

    // ========== 輔助方法 ==========

    /**
     * 取得學位的顯示文字
     */
    getDegreeText(degree) {
      const degreeMap = {
        8: "Bachelor",
        10: "Master",
        12: "Doctoral"
      };
      return degreeMap[degree] || "";
    },

    /**
     * 格式化日期時間
     */
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '';

      try {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('Date format error:', error);
        return dateTimeString;
      }
    },

    // ========== 付款相關 ==========

    /**
     * 處理付款證明檔案選擇
     */
    async handlePaymentProofChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 檢查檔案大小（10MB 限制）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "The file size must be less than 10MB.",
          confirmButtonText: "OK"
        });
        event.target.value = '';
        return;
      }

      // 檢查檔案類型
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File Type",
          text: "Please upload an image file (JPG, PNG, GIF) or PDF.",
          confirmButtonText: "OK"
        });
        event.target.value = '';
        return;
      }

      this.uploadingProof = true;

      try {
        // 將檔案轉換為 Base64
        const base64Data = await this.fileToBase64(file);

        // 準備上傳資料
        const uploadData = {
          asId: this.asId,
          orderId: this.orderInfo.applyOrderId,
          fileName: file.name,
          base64Data: base64Data
        };

        // 調用 API 上傳付款證明
        const result = await applyStudentService.uploadPaymentProof(uploadData);

        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Upload Successful",
            text: "Payment proof has been uploaded successfully.",
            confirmButtonText: "OK"
          });

          // 重新載入訂單資訊
          await this.loadUserOrder();
        } else {
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text: result.message || "Failed to upload payment proof.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Upload payment proof error:", error);
        Swal.fire({
          icon: "error",
          title: "Upload Error",
          text: "An error occurred while uploading. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.uploadingProof = false;
        event.target.value = '';
      }
    },

    /**
     * 處理簽名申請表檔案選擇
     */
    async handleSignedFormChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 檢查檔案大小（10MB 限制）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "The file size must be less than 10MB.",
          confirmButtonText: "OK"
        });
        event.target.value = '';
        return;
      }

      // 檢查檔案類型
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File Type",
          text: "Please upload an image file (JPG, PNG, GIF) or PDF.",
          confirmButtonText: "OK"
        });
        event.target.value = '';
        return;
      }

      this.uploadingSignedForm = true;

      try {
        // 將檔案轉換為 Base64
        const base64Data = await this.fileToBase64(file);

        // 準備上傳資料
        const uploadData = {
          asId: this.asId,
          orderId: this.orderInfo.applyOrderId,
          fileName: file.name,
          base64Data: base64Data
        };

        // 調用 API 上傳簽名申請表
        const result = await applyStudentService.uploadSignedApplicationForm(uploadData);

        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Upload Successful",
            text: "Signed application form has been uploaded successfully.",
            confirmButtonText: "OK"
          });

          // 重新載入申請表資料以更新簽名表單資訊
          await this.loadUserApplication();
        } else {
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text: result.message || "Failed to upload signed application form.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Upload signed form error:", error);
        Swal.fire({
          icon: "error",
          title: "Upload Error",
          text: "An error occurred while uploading. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.uploadingSignedForm = false;
        event.target.value = '';
      }
    },

    /**
     * 將檔案轉換為 Base64
     */
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    /**
     * 處理付款
     */
    async handlePayment() {
      // 需要檢查是否選擇了付款方式
      if (!this.paymentMethod) {
        Swal.fire({
          icon: "warning",
          title: "Payment Method Required",
          text: "Please select a payment method.",
          confirmButtonText: "OK"
        });
        return;
      }

      // 檢查是否有申請的學程
      if (this.userPrograms.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Programs",
          text: "Please apply for at least one program in Step 2 before making payment.",
          confirmButtonText: "OK"
        });
        return;
      }

      if (this.isSaving) return;
      this.isSaving = true;

      try {
        if (this.paymentMethod === 'credit') {
          // TODO: 信用卡付款流程
          Swal.fire({
            icon: "info",
            title: "Credit Card Payment",
            text: "",
            confirmButtonText: "OK"
          });
        } else if (this.paymentMethod === 'domestic') {
          // TODO: 國內轉帳付款流程
          Swal.fire({
            icon: "info",
            title: "Domestic Payment",
            text: "",
            confirmButtonText: "OK"
          });
        } else if (this.paymentMethod === 'foreign') {
          // TODO: 國外轉帳付款流程
          Swal.fire({
            icon: "info",
            title: "Foreign Payment",
            text: "",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Payment error:", error);
        Swal.fire({
          icon: "error",
          title: "Payment Error",
          text: "An error occurred during payment. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    // ========== 表單提交 ==========

    /**
     * 提交整個申請表
     */
    async submitApplication() {
      // TODO: 實作提交申請表功能
      // 需要檢查所有必填項目是否完成

      // 檢查是否已付款
      // TODO: 從後端檢查付款狀態
      // if (!this.isPaid) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Payment Required",
      //     text: "Please complete the payment before submitting your application.",
      //     confirmButtonText: "OK"
      //   });
      //   return;
      // }

      // 確認提交
      const result = await Swal.fire({
        title: "Submit Application?",
        text: "Are you sure you want to submit your application? You will not be able to make changes after submission.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, submit",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#580d63"
      });

      if (!result.isConfirmed) {
        return;
      }

      if (this.isSaving) return;
      this.isSaving = true;

      try {
        // TODO: 調用提交 API
        // const submitResult = await applyStudentService.submitUserApplication();
        // 
        // if (submitResult.success) {
        //   Swal.fire({
        //     icon: "success",
        //     title: "Application Submitted!",
        //     text: "Your application has been successfully submitted.",
        //     confirmButtonText: "OK"
        //   }).then(() => {
        //     // 跳轉到完成頁面或首頁
        //     this.$router.push("/");
        //   });
        // } else {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Submission Failed",
        //     text: submitResult.message || "Failed to submit application. Please try again.",
        //     confirmButtonText: "OK"
        //   });
        // }

        // 暫時顯示未實作訊息
        Swal.fire({
          icon: "info",
          title: "Submit Function",
          text: "Application submission is not yet fully implemented. Payment integration is required first.",
          confirmButtonText: "OK"
        });

      } catch (error) {
        console.error("Submit application error:", error);
        Swal.fire({
          icon: "error",
          title: "Submission Error",
          text: "An error occurred while submitting. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    // ========== 頁面導覽 ==========

    gotoForm_1() {
      this.$router.push("/Apply/1").then(() => {
        window.scrollTo(0, 0);
      });
    },

    gotoForm_2() {
      this.$router.push("/Apply/2").then(() => {
        window.scrollTo(0, 0);
      });
    },

    gotoPrev() {
      this.$router.push("/Apply/5").then(() => {
        window.scrollTo(0, 0);
      });
    },

    gotoNext() {
      this.$router.push("/Apply/Check").then(() => {
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>
